module.exports = __webpack_public_path__ + "img/lupa.8d9f45b3.svg";